import { AssetDetailsSummary } from '@Types/asset.types';
import { NamespacedStoreState } from '@Types/store.types';
import { moduleNamespace } from '@Store/config.store';

export const selectAssetById = (
	state: NamespacedStoreState,
	id: string,
): AssetDetailsSummary | undefined =>
	state[moduleNamespace].assetSummary?.assets[id];
